import React, { useEffect } from 'react';
import {
  Content,
  InfoText,
  InviteButton,
  NoteText,
  OrText,
  PageContainer,
  ReferralIcon,
  SubtitleText,
} from './ReferralsPage.styles';
import { Text24Bold } from '../../components/utils/Text/Text.styles';
import { Input, ReferralInfo, ReferralsList } from '../../components';
import { useSelector } from 'react-redux';
import { selectUser } from '../../store/slices/user/slice';
import { ReactComponent as CopyIcon } from '../../assets/icons/copy.svg';
import { notifyInfo } from '../../utils/notify';
import { useNavigate } from 'react-router-dom';
import { HOME } from '../../components/App/routes';

const ReferralsPage = () => {
  const user = useSelector(selectUser);
  const navigate = useNavigate();

  const hasReferrals = !!user.referralInfo.referrals.length;

  useEffect(() => {
    if (!user.featureEnabled) {
      navigate(HOME);
    }
  }, [user.featureEnabled, navigate]);

  const copyInviteCode = () => {
    navigator.clipboard.writeText(user.referralInfo.code);
    notifyInfo('Invite code copied!');
  };

  const copyInviteText = () => {
    const text = `Access TLINK with my invite code: ${user.referralInfo.code}\nhttps://creators.tlink.me/sign-up?invite=${user.referralInfo.code}`;
    navigator.clipboard.writeText(text);
    notifyInfo('Text copied!');
  };

  return (
    <PageContainer>
      {hasReferrals ? (
        <ReferralsList />
      ) : (
        <Content>
          <ReferralIcon />
          <Text24Bold>Earn from Your Network!</Text24Bold>
          <SubtitleText>Invite creators to the platform and earn 3.0% of their gross earnings.</SubtitleText>
          <Input
            label="Invite Code"
            value={user.referralInfo.code}
            disabled
            rightIcon={<CopyIcon />}
            onRightIconClick={copyInviteCode}
          />
          <OrText>or</OrText>
          <InviteButton title="Invite Friend" onClick={copyInviteText} />
          <InfoText>Here's how it works:</InfoText>
          <ReferralInfo />
          <NoteText>Grow your community, multiply your earnings!</NoteText>
        </Content>
      )}
    </PageContainer>
  );
};

export default ReferralsPage;
